/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const SET_NO_GEO = 'SET_NO_GEO';
export const GET_ALL_GEOS = 'GET_ALL_GEOS';
export const SET_SELECTED_GEO = 'SET_SELECTED_GEO';
export const GET_ALL_ENV_TYPES = 'GET_ALL_ENV_TYPES';
export const SET_SELECTED_INSTANCE = 'SET_SELECTED_INSTANCE';
